/* gtl-deep-sleep-physical-gift-multi-add-disabled-20260731: Deep Sleep €75 tier is digital-bonus-only; removed Nose/Mouth physical gift cart interceptor. */

/* gtl-payment-badges-cod-hotfix-20260604: replace advertorial fake payment text badges with real cart drawer SVG payment badges and COD emphasis. */
(function () {
  const TARGET_PATH = '/pages/just-breath-nose-strips-sleep-breathing';
  const STYLE_ID = 'gtl-payment-badges-cod-hotfix-style';

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .gtl-phc-v4 .payment-badges-block.advertorial-payment-badges{max-width:1180px;margin:0 auto 28px;background:#fff;border:1px solid #eadfc8;border-top:0;border-radius:0 0 22px 22px;display:flex;align-items:center;justify-content:space-between;gap:18px;flex-wrap:wrap;padding:20px 22px;box-shadow:0 16px 36px rgba(60,45,24,.06)}
      .gtl-phc-v4 .advertorial-payment-badges .cod-payment-highlight{display:flex;align-items:center;gap:12px;background:#0b2d66;color:#fff;border-radius:18px;padding:14px 18px;box-shadow:0 14px 28px rgba(11,45,102,.18);min-width:min(100%,360px)}
      .gtl-phc-v4 .advertorial-payment-badges .cod-icon{width:38px;height:38px;border-radius:50%;display:grid;place-items:center;background:#fff;color:#0b2d66;font-size:20px;flex:0 0 auto;font-weight:900}
      .gtl-phc-v4 .advertorial-payment-badges .cod-payment-highlight strong{display:block;font-size:17px;line-height:1.1;color:#fff}
      .gtl-phc-v4 .advertorial-payment-badges .cod-payment-highlight span:last-child{display:block;color:rgba(255,255,255,.82);font-size:13px;font-weight:700;margin-top:3px}
      .gtl-phc-v4 .advertorial-payment-badges .payment-badges{list-style:none;margin:0;padding:0;display:flex;align-items:center;justify-content:center;gap:9px;flex-wrap:wrap}
      .gtl-phc-v4 .advertorial-payment-badges .list-payment__item{display:flex;margin:0;padding:0}
      .gtl-phc-v4 .advertorial-payment-badges svg{width:45px;height:auto;display:block;border-radius:5px;box-shadow:0 4px 10px rgba(20,20,20,.06)}
      .gtl-phc-v4 .advertorial-payment-badges .payment-badges-copy{width:100%;margin:0;color:#5f6470;font-size:13px;text-align:center;font-weight:700}
      @media(max-width:760px){.gtl-phc-v4 .payment-badges-block.advertorial-payment-badges{padding:18px;justify-content:center}.gtl-phc-v4 .advertorial-payment-badges .cod-payment-highlight{width:100%}}
    `;
    document.head.appendChild(style);
  }

  function cloneRealPaymentBadges() {
    const source = document.querySelector('.cart-drawer .payment-badges-block .payment-badges') || document.querySelector('cart-drawer .payment-badges-block .payment-badges') || document.querySelector('.payment-badges-block .payment-badges');
    if (!source) return null;
    const clone = source.cloneNode(true);
    clone.querySelectorAll('script').forEach((node) => node.remove());
    return clone;
  }

  function buildFallbackBadges() {
    const ul = document.createElement('ul');
    ul.className = 'payment-badges';
    ul.setAttribute('role', 'list');
    ['Visa', 'PayPal', 'Apple Pay', 'Google Pay'].forEach((label) => {
      const li = document.createElement('li');
      li.className = 'list-payment__item';
      li.textContent = label;
      li.style.cssText = 'border:1px solid #d9d9d9;background:#fafafa;border-radius:6px;padding:8px 12px;font-weight:900;color:#555;font-size:13px';
      ul.appendChild(li);
    });
    return ul;
  }

  function buildPaymentBlock() {
    const block = document.createElement('div');
    block.className = 'payment-badges-block advertorial-payment-badges';
    block.setAttribute('aria-label', 'Сигурно плащане и наложен платеж');
    block.setAttribute('data-gtl-payment-badges-cod-hotfix', 'true');
    block.innerHTML = '<div class="cod-payment-highlight"><span class="cod-icon" aria-hidden="true">✓</span><div><strong>Наложен платеж</strong><span>Поръчваш сега, плащаш на куриера при получаване.</span></div></div>';
    block.appendChild(cloneRealPaymentBadges() || buildFallbackBadges());
    const copy = document.createElement('p');
    copy.className = 'payment-badges-copy';
    copy.innerHTML = 'Реални поддържани методи за онлайн плащане + най-предпочитаният вариант за България: <strong>наложен платеж</strong>.';
    block.appendChild(copy);
    return block;
  }

  function applyPaymentBadgesHotfix() {
    if (window.location.pathname !== TARGET_PATH) return;
    const payrows = document.querySelectorAll('.gtl-phc-v4 .payrow');
    if (!payrows.length) return;
    injectStyles();
    payrows.forEach((payrow) => {
      if (payrow.dataset.gtlPaymentBadgesCodHotfix === 'true') return;
      payrow.dataset.gtlPaymentBadgesCodHotfix = 'true';
      payrow.replaceWith(buildPaymentBlock());
    });
  }

  onReady(function () {
    applyPaymentBadgesHotfix();
    setTimeout(applyPaymentBadgesHotfix, 500);
    setTimeout(applyPaymentBadgesHotfix, 1500);
    setTimeout(applyPaymentBadgesHotfix, 3500);
  });
})();

